import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Notification } from '../notification.model';
import { NotificationActions, NotificationActionTypes } from '../actions/notification.actions';

// export interface State extends EntityState<Notification> {
//   Loaded: boolean;
//   Loading: boolean;
//   isConfirm: boolean;
// }

// export const adapter: EntityAdapter<Notification> = createEntityAdapter<Notification>({
//   selectId: info => info.type
// });

// export const initialState: State = adapter.getInitialState({
//   Loaded: false,
//   Loading: false,
//   isConfirm: false
// });

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: Notification[];
  isConfirm: boolean;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: [],
  isConfirm: false
};

export function reducer(
  state = initialState,
  action: NotificationActions
): State {
  switch (action.type) {
    case NotificationActionTypes.GetNotifications: {
      return {...state, Loaded: false, Loading: true, isConfirm: true};
    }

    case NotificationActionTypes.UpsertNotifications: {
      return {...state, Loaded: true, Loading: false, isConfirm: action.payload.isConfirm, entities: action.payload.notifications};
    }

    case NotificationActionTypes.UpdateNotifications: {
      return {...state, Loaded: false, Loading: true, isConfirm: true};
    }

    case NotificationActionTypes.ClearNotifications: {
      return {...state, Loaded: true, Loading: false, isConfirm: false, entities: []};
    }

    case NotificationActionTypes.UpdateNotificationsFail: {
      return {...state, Loaded: true, Loading: false, isConfirm: false};
    }

    default: {
      return state;
    }
  }
}

// export const {
//   selectIds,
//   selectEntities,
//   selectAll,
//   selectTotal,
// } = adapter.getSelectors();
